import * as Sentry from '@sentry/react'
import {
  clearErrors,
  createConsumerAccount,
  login,
  SHOW_ERROR,
  SUBMIT_PERSONAL_INFO,
  SUBMIT_PERSONAL_INFO_SUCCESS_NEED_LICENSE,
  updateDasherApplicant,
} from '.'
import * as api from '../api'
import {
  trackDasherLogin,
  trackSignupAndSubmitProfileFailure,
  trackSubmitProfileFailure,
} from '../events'
import * as DA from '../typeModules/events'
import { getToken } from '../utilities/configureApi'
import { deleteUserSessionToken } from '../utilities/SimpleStore'
import { getUtmSource } from '../utilities/utmSource'

export const submitPersonalInfo = (
  uniqueLink,
  args,
  application,
  isLoggedIn,
  vehicleTypes,
  offerLetterSigned,
  isIdentityMigration: boolean = false
) => {
  const { email, hasConsumerAccount, phoneNumberComponents } = application
  const phoneNumber = phoneNumberComponents.internationalNumber
  const addLicense =
    args.vehicleType && vehicleTypes[args.vehicleType].needs_license_info
  Sentry.setUser({ email })
  return async (dispatch, getState) => {
    const utmSource = getUtmSource()
    const consumerEmail = getState().consumerEmail
    dispatch({ type: SUBMIT_PERSONAL_INFO.IN_PROGRESS })
    Sentry.setContext('isConsumer', { hasConsumerAccount })
    try {
      if (!hasConsumerAccount) {
        // HACK: prevent dasher applications from being tied
        // to the currently logged in user when going to the
        // dasher application flow **when you've just signed up**
        //
        // See https://doordash.atlassian.net/browse/DX-2212
        // and https://github.com/doordash/doorstep-django/pull/5652
        deleteUserSessionToken()
        await api.logoutPreExistingUser(consumerEmail, email)

        const consumerDetails = Object.assign({ email, phoneNumber }, args)
        await dispatch(createConsumerAccount(consumerDetails))
        await dispatch(
          updateDasherApplicant(uniqueLink, {
            ...args,
            utmSource,
            offerLetterSigned,
          })
        )
        await dispatch(
          login(email, args.password, uniqueLink, isIdentityMigration)
        )
      } else {
        await dispatch(
          updateDasherApplicant(uniqueLink, {
            ...args,
            utmSource,
            offerLetterSigned,
          })
        )
      }

      const isToken: boolean = getToken() !== ''

      dispatch(
        trackDasherLogin({
          action: DA.EventActions.Submit,
          name: 'token',
          value: isToken,
        })
      )

      if (addLicense) {
        dispatch({
          type: SUBMIT_PERSONAL_INFO_SUCCESS_NEED_LICENSE,
        })
      }

      dispatch({ type: SUBMIT_PERSONAL_INFO.SUCCESS })
      dispatch(clearErrors)
    } catch (error) {
      if (isLoggedIn) {
        dispatch(trackSubmitProfileFailure(error))
      } else {
        Sentry.captureException(error)
        dispatch(trackSignupAndSubmitProfileFailure(error))
      }

      dispatch({ type: SUBMIT_PERSONAL_INFO.FAIL, payload: error.data })
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}
